module.exports = __webpack_public_path__ + "static/img/celoscope-17.2d7ca87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-17.jpg
// module id = +4xb
// module chunks = 51